import React, { useContext, useState } from "react";
import toast from "react-hot-toast";
import { FaUser } from "react-icons/fa";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../Context/UseContext";
import logo from "../../../Images/logo.svg";
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, logOut } = useContext(AuthContext);

  const handleLogout = () => {
    logOut()
      .then(() => {
        toast.success("Sign-out successful");
      })
      .catch((error) => {
        console.error(error);
      });
  };
  return (
    <div class="bg-white">
      <div class="px-4 py-5 mx-auto sm:max-w-xl md:max-w-full  shadow-lg md:px-24 lg:px-8">
        <div class="relative flex items-center justify-between">
          <Link to="/" title="FoodFly" class="inline-flex items-center">
            <img src={logo} alt="" />
          </Link>
          <ul class="flex items-center hidden space-x-8 lg:flex">
            <li>
              <Link
                to="/home"
                class="font-medium tracking-wide text-black transition-colors duration-200 hover:text-teal-accent-400"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/blog"
                class="font-medium tracking-wide text-black transition-colors duration-200 hover:text-teal-accent-400"
              >
                Blog
              </Link>
            </li>
            {user?.email ? (
              <>
                <li>
                  <Link
                    to="/reviews"
                    class="font-medium tracking-wide text-black transition-colors duration-200 hover:text-teal-accent-400"
                  >
                    My Reviews
                  </Link>
                </li>
                <li>
                  <Link
                    to="/addservice"
                    class="font-medium tracking-wide text-black transition-colors duration-200 hover:text-teal-accent-400"
                  >
                     Add Services
                  </Link>
                </li>
              </>
            ) : (
              <></>
            )}
            <li>
                  <Link
                    to="/services"
                    class="font-medium tracking-wide text-black transition-colors duration-200 hover:text-teal-accent-400"
                  >
                   My Services
                  </Link>
                </li>
          </ul>
          <ul class="flex items-center hidden space-x-8 lg:flex">
            {user?.uid ? (
              <>
                <li>
                  <Link
                    onClick={handleLogout}
                    class="inline-flex items-center justify-center h-12 px-6 font-medium tracking-wide text-white transition duration-200 rounded shadow-md bg-blue-500 hover:bg-deep-purple-accent-700 focus:shadow-outline focus:outline-none"
                    aria-label="Sign up"
                    title="Sign up"
                  >
                    LogOut
                  </Link>
                </li>
                <li className=" text-lg font-medium">{user?.displayName}</li>
              </>
            ) : (
              <>
                <li>
                  <Link
                    to="/Login"
                    class="inline-flex items-center justify-center h-12 px-6 font-medium tracking-wide text-white transition duration-200 rounded shadow-md bg-blue-500 hover:bg-deep-purple-accent-700 focus:shadow-outline focus:outline-none"
                    aria-label="Sign up"
                    title="Sign up"
                  >
                    Sign In
                  </Link>
                </li>
              </>
            )}
            {user?.email ? (
              <>
                <img
                  className=" rounded-full  w-16"
                  src={user?.photoURL}
                  alt=""
                />
              </>
            ) : (
              <>
                <span>
                  <FaUser></FaUser>
                </span>
              </>
            )}
          </ul>
          <div class="lg:hidden">
            <button
              aria-label="Open Menu"
              title="Open Menu"
              class="p-2 -mr-1 transition duration-200 rounded focus:outline-none focus:shadow-outline"
              onClick={() => setIsMenuOpen(true)}
            >
              <svg class="w-5 text-gray-600" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M23,13H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,13,23,13z"
                />
                <path
                  fill="currentColor"
                  d="M23,6H1C0.4,6,0,5.6,0,5s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,6,23,6z"
                />
                <path
                  fill="currentColor"
                  d="M23,20H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,20,23,20z"
                />
              </svg>
            </button>
            {isMenuOpen && (
              <div class="absolute top-0 left-0 w-full">
                <div class="p-5 bg-white border rounded shadow-sm">
                  <div class="flex items-center justify-between mb-4">
                    <div>
                      <Link
                        to="/"
                        title="FoodFly"
                        class="inline-flex items-center"
                      >
                        <span class="ml-2 text-xl font-bold tracking-wide text-gray-800 uppercase">
                          <img src={logo} alt="" />
                        </span>
                      </Link>
                    </div>
                    <div>
                      <button
                        aria-label="Close Menu"
                        title="Close Menu"
                        class="p-2 -mt-2 -mr-2 transition duration-200 rounded hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        <svg class="w-5 text-gray-600" viewBox="0 0 24 24">
                          <path
                            fill="currentColor"
                            d="M19.7,4.3c-0.4-0.4-1-0.4-1.4,0L12,10.6L5.7,4.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l6.3,6.3l-6.3,6.3 c-0.4,0.4-0.4,1,0,1.4C4.5,19.9,4.7,20,5,20s0.5-0.1,0.7-0.3l6.3-6.3l6.3,6.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L13.4,12l6.3-6.3C20.1,5.3,20.1,4.7,19.7,4.3z"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <nav>
                    <ul class="space-y-4">
                      <li>
                        <Link
                          to="/home"
                          aria-label="Our product"
                          title="Our product"
                          class="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                        >
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/blog"
                          aria-label="Our product"
                          title="Our product"
                          class="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                        >
                          Blog
                        </Link>
                      </li>
                      <li>
                            <Link
                              to="/services"
                              aria-label="About us"
                              title="About us"
                              class="font-medium tracking-wide text-black transition-colors duration-200 hover:text-teal-accent-400"
                            >
                            My Services
                            </Link>
                          </li>
                      {user?.email ? (
                        <>
                          <li>
                            <Link
                              to="/reviews"
                              class="font-medium tracking-wide text-black transition-colors duration-200 hover:text-teal-accent-400"
                            >
                              My Reviews
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/addservice"
                              aria-label="About us"
                              title="About us"
                              class="font-medium tracking-wide text-black transition-colors duration-200 hover:text-teal-accent-400"
                            >
                            Add Services
                            </Link>
                          </li>
                        </>
                      ) : (
                        <></>
                      )}
                      {user?.email ? (
                        <>
                          <li>
                            <Link
                              onClick={logOut}
                              class="inline-flex items-center justify-center w-full h-12 px-6 font-medium tracking-wide bg-blue-600 text-white transition duration-200 rounded shadow-md bg-deep-purple-accent-400 hover:bg-deep-purple-accent-700 focus:shadow-outline focus:outline-none"
                              aria-label="Sign In"
                              title="Sign In"
                            >
                              LogOut
                            </Link>
                          </li>
                          <li>{user?.displayName}</li>
                        </>
                      ) : (
                        <>
                          <li>
                            <Link
                              to="/login"
                              class="inline-flex items-center justify-center w-full h-12 px-6 font-medium tracking-wide bg-blue-600 text-white transition duration-200 rounded shadow-md bg-deep-purple-accent-400 hover:bg-deep-purple-accent-700 focus:shadow-outline focus:outline-none"
                              aria-label="Sign In"
                              title="Sign In"
                            >
                              Sign In
                            </Link>
                          </li>
                        </>
                      )}
                      {user?.email ? (
                        <>
                          <img
                            className=" rounded-full  w-16"
                            src={user?.photoURL}
                            alt=""
                          />
                        </>
                      ) : (
                        <>
                          <span>
                            <FaUser></FaUser>
                          </span>
                        </>
                      )}
                    </ul>
                  </nav>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
